import { useDispatch } from 'react-redux';
import { snackbarShowMessage } from '../redux/actions/snackbarActions';
import { validateHourRange } from '../utils/helpers';
import { useTranslation } from 'react-i18next';

export function useValidationHoursAndEmitMessage({
  body,
  translation,
  dispatch,
}) {
  const timePairs = getTimePairs();
  const timePairsAreValid = timePairs.every(([openTime, closeTime]) =>
    validateHourRange(body[openTime], body[closeTime], 30),
  );

  if (timePairsAreValid) return true;

  dispatch(
    snackbarShowMessage(translation('operationHours.error.littleRange')),
  );
  return false;
}

function getTimePairs() {
  const prefixes = ['dr', 'dt'];
  const toTimePair = prefix => [`${prefix}TimeOpen`, `${prefix}TimeClose`];
  return prefixes.map(toTimePair);
}
